<div *ngIf="(evaluation$ | async)" [hidden]="hidden$ | async">
  <div [ngStyle]="{'padding-bottom': spacing[size-1]}"></div>
</div>
